import * as React from 'react';

interface Props {
    defaultValue: string;
    optionsDefinition: any;
    onSelect: (partStatus: string) => void;
    
};

interface State {

};

// const STATUS_OPTIONS_DEFINITION = [
//     {
//         value: "none",
//         label: "None"
//     },
//     {
//         value: "created",
//         label: "Created"
//     },
//     {
//         value: 'entered',
//         label: 'Entered'
//     },
//     {
//         value: 'shipped',
//         label: "Shipped"
//     },
//     {
//         value: 'returned',
//         label: 'Returned'
//     },
// ]

export class ClassSelectDropdown extends React.Component<Props, State> {

    state: State = {}

    getDefition = () => {
        return this.props.optionsDefinition;
    }

    render() {
        let partOptions: JSX.Element[] = [];

        const OPTIONS = this.getDefition();

        for (let i = 0; i < OPTIONS.length; i++) {
            const selected = this.props.defaultValue === OPTIONS[i].value;

            partOptions.push(
                <option selected={selected} value={OPTIONS[i].value}>{OPTIONS[i].label}</option>
            );
        }

        return <span>
            <b style={{ marginRight: '15px' }}>Choose a class to view:</b>
            <div className="bp3-select .modifier">
                <select onChange={(event) => {
                    if (this.props.onSelect) {
                        this.props.onSelect(event.target.value);
                    }
                }}>
                    {partOptions}
                </select>
            </div>
        </span>
    }
}
